import { useEffect, useRef } from 'react';
import { useSocketStore } from '../../stores/useSocketStore';
import { useTripAlertsAnalysisStore } from '../../stores/analysis/useTripAlertsAnalysisStore';

export function useTripAlertsAnalysisSocket() {

    const socket = useSocketStore(
        state => state.socket
    );

    const countRef = useRef(0);


    useEffect(() => {

        if (!socket) {
            return;
        }

        const {
            setAlert
        } = useTripAlertsAnalysisStore.getState();

        const handleAlert = (data) => {

            countRef.current++;

            console.log(
                'alerts',
                countRef.current
            );

            setAlert(data);

        };

        socket.on('trip:alerts:analysis', handleAlert);

        return () => {

            socket.off('trip:alerts:analysis', handleAlert);

        };

    }, [socket]);

}